import { useEffect } from 'react'
import { testPostHogUpload } from '@/utils/test-posthog-upload'

export const PostHogTestRunner = () => {
  useEffect(() => {
    console.log('🔧 PostHogTestRunner mounted, DEV mode:', import.meta.env.DEV)
    
    if (import.meta.env.DEV) {
      // Run test after a short delay to ensure everything is loaded
      const timer = setTimeout(() => {
        console.log('🚀 Starting PostHog source map test...')
        testPostHogUpload()
          .then((result) => {
            console.log('✅ PostHog test completed successfully:', result)
          })
          .catch((error) => {
            console.error('❌ PostHog test failed with error:', error)
          })
      }, 2000)

      return () => clearTimeout(timer)
    } else {
      console.log('⚠️ PostHog test skipped - not in development mode')
    }
  }, [])

  return null
}